import clsx from 'clsx';
import React, { useState } from 'react';

import EmailLeadCapture from '@components/EmailLeadCapture';
import IconClose from '@components/Images/Rebranding/IconClose';
import { useAppContext } from '@contexts/AppContext';
import Modal from '@mui/material/Modal';
import { static_privacy_path } from '@routes';
import { FormLocation } from '@utils/enums';

import { NEWSLETTER_LEAD } from './NewsletterCard/interfaces';

interface SignUpModalProps {
  description: string;
  headline?: string;
  name?: string;
  newsletterIds?: number[];
  onClose: () => void;
  subscribeToAllNewsletters?: boolean;
}

const SUBSCRIBE_TO_ALL_NEWSLETTERS = 'Subscribe to All Newsletters';

const SignUpModal = ({
  description,
  headline = SUBSCRIBE_TO_ALL_NEWSLETTERS,
  name,
  newsletterIds = [],
  onClose,
  subscribeToAllNewsletters = false,
}: SignUpModalProps) => {
  const [isOpen, setIsOpen] = useState(!!newsletterIds.length || subscribeToAllNewsletters);
  const { isGdprRequired } = useAppContext();

  const handleCloseModal = () => {
    onClose();
    setIsOpen(false);
  };

  return (
    <Modal
      data-testid="newsletter-signup-modal"
      open={isOpen}
      disableScrollLock={true}
      className="fixed bottom-0 left-0 right-0 top-0 flex items-center justify-center"
    >
      <div className="relative mx-8 w-full max-w-[450px] bg-white sm:mx-0 sm:max-w-[820px]">
        <IconClose
          className="absolute right-8 top-8 h-[26px] w-[26px] cursor-pointer"
          strokeWidth={1}
          onClick={handleCloseModal}
        />
        <div className="flex w-full justify-center">
          <div className=" px-32 py-64 sm:max-w-[623px] sm:px-0">
            <div>
              <h3 className="m-0 pb-12 font-suisse-neue text-subheadline-sm">{headline}</h3>
              <span className="font-suisse-intl text-button-md">{description}</span>
            </div>
            <div className="mt-24 flex w-full justify-center sm:gap-x-16">
              <EmailLeadCapture
                buttonClassName="w-full sm:max-w-[260px]"
                buttonText={name ? `Subscribe to ${name}` : SUBSCRIBE_TO_ALL_NEWSLETTERS}
                formClassName="mb-8 sm:col-span-2"
                formLocation={FormLocation.NewsletterLanding}
                gdprClassName="mb-16"
                inputClassName={clsx('w-full', {
                  'sm:w-[260px]': headline === SUBSCRIBE_TO_ALL_NEWSLETTERS,
                  'sm:w-[360px]': headline !== SUBSCRIBE_TO_ALL_NEWSLETTERS,
                })}
                gdpr={isGdprRequired}
                newsletterIds={newsletterIds}
                inputWrapperClassName="max-w-full sm:max-w-[260px]"
                leadType={NEWSLETTER_LEAD}
                redirectToOnSuccess={''}
                signInOptionClass="text-center sm:text-left"
                subscribeToAllNewsletters={subscribeToAllNewsletters}
                triggerNewsletterEvent={!subscribeToAllNewsletters}
              />
            </div>
            <div className="font-suisse-screen text-overline-sm">
              By providing your email, you agree to The Information&rsquo;s{' '}
              <a className="text-primary-magenta" href={static_privacy_path()}>
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SignUpModal;
